import { fromJS, OrderedMap, Map } from 'immutable';
import { stringify } from 'query-string';
import { dispatch } from 'nike-re-framejs';
import { clearPersistentError, makeError, setPersistentError } from 'nike-form-js';

import i18n from '@i18n';

function convertResponseFromBackend(errors) {
    const serverErrors = fromJS(errors);
    return serverErrors
        .keySeq()
        .reduce((acc, item) => acc.set(item, makeError(serverErrors.get(item).map(key => i18n(key)))), OrderedMap());
}

export const paramsSerializer = {
    traditional(params) {
        return stringify(params);
    }
};

export function toWwwForm(data) {
    return stringify(data);
}

export const catcher = {
    handleFormErrors(error, form, fieldForError = 'amount') {
        if (error && error._legacy && error._fieldErrors) {
            clearPersistentError(form);
            setPersistentError(form, convertResponseFromBackend(error._fieldErrors));
            return Promise.resolve(error.response);
        }
        if (error && !error._legacy && (error?.response?.data?.fieldErrors || error?.response?.data?.message)) {
            const { fieldErrors, message } = error.response.data;
            clearPersistentError(form);
            let err;
            if (fieldErrors) {
                err = fromJS(fieldErrors).reduce((acc, key, path) => acc.set(path, makeError([i18n(key)])), Map());
            } else {
                const trans = i18n(message);
                err = Map().set(fieldForError, makeError([message === trans ? i18n('commons.message.error') : trans]));
            }
            setPersistentError(form, err);
            return Promise.resolve(error.response);
        }
        if (error && !error._legacy && error?.response?.data?.formError) {
            const payload = error.response.data;
            dispatch(['ui.showMasterError', payload.formError]);
            return Promise.resolve(error.response);
        }
        return Promise.reject(error);
    },
    handleMasterError(error, onClose, htmlMessages) {
        if (error && error._legacy) {
            if (error._sessionExpired) {
                dispatch(['account.onSessionExpired']);
                return Promise.resolve(error.response);
            }
            if (error._masterError) {
                dispatch(['ui.showMasterError', error._masterError, null, onClose, htmlMessages]);
                return Promise.resolve(error.response);
            }
            if (error._errors && error._errors.FORM_ERROR) {
                dispatch(['ui.showMasterError', error._errors.FORM_ERROR, null, onClose]);
                return Promise.resolve(error.response);
            }
        }
        console.warn('axios error', error);
        dispatch(['ui.showMasterError', 'error.unexpected.message', 'error.unexpected.title', onClose]);
        return Promise.resolve(error ? error.response : null);
    },
    swallow(error) {
        return Promise.resolve(error ? error.response : null);
    }
};
